import { PickersCalendarHeaderProps } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';

import { Button } from '@/components/Button';

/**
 * Кастомный заголовок календаря с раздельным выбором месяца и года.
 */
export const CalendarHeader = observer(
  ({
    currentMonth,
    onMonthChange,
    onViewChange,
  }: PickersCalendarHeaderProps & {
    onMonthChange: (date: DateTime, selectionState?: 'partial' | 'finish') => void;
    onViewChange: (view: 'day' | 'month' | 'year') => void;
  }) => {
    if (!currentMonth) {
      return null;
    }

    const monthName = currentMonth
      .setLocale('ru')
      .toFormat('LLLL')
      .replace(/^./, (c) => c.toUpperCase());
    const year = currentMonth.year;

    const handlePrevMonth = (e: React.MouseEvent) => {
      e.stopPropagation();
      onMonthChange?.(currentMonth.minus({ months: 1 }), 'finish');
    };

    const handleNextMonth = (e: React.MouseEvent) => {
      e.stopPropagation();
      onMonthChange?.(currentMonth.plus({ months: 1 }), 'finish');
    };

    const handleMonthClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      onViewChange?.('month');
    };

    const handleYearClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      onViewChange?.('year');
    };

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px 16px',
          gap: '8px',
        }}
      >
        <Button onClick={handlePrevMonth} variant="text" sx={{ minWidth: '32px', padding: '4px' }}>
          {'<'}
        </Button>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <Button
            onClick={handleMonthClick}
            variant="text"
            sx={{ textTransform: 'capitalize', padding: '4px 8px' }}
          >
            {monthName}
          </Button>
          <Button onClick={handleYearClick} variant="text" sx={{ padding: '4px 8px' }}>
            {year}
          </Button>
        </div>
        <Button onClick={handleNextMonth} variant="text" sx={{ minWidth: '32px', padding: '4px' }}>
          {'>'}
        </Button>
      </div>
    );
  },
);
